import React from 'react';
import { returnTime } from '../../common/utils';
import { Avatar, Icon } from 'antd';
import { CommentBox } from './style';

const Comment = ({ data, isCreator, onDelete }) => {
	const email = data.User.email && data.User.email.split('@')[0];
	return (
		<CommentBox className={isCreator ? 'msg-row creator' : 'msg-row'}>
			<div className="msg-row-info">
				<Avatar>{email.slice(0, 1).toUpperCase()}</Avatar>
				<div className="msg-row-info-name">
					{email}
					<br />
				</div>
				<div className="msg-row-info-date">
					{returnTime(data.created_at)}
				</div>
			</div>
			<div className="msg-row-content">{data.message}</div>
			{isCreator && <Icon type="delete" onClick={onDelete} />}
		</CommentBox>
	);
};

export default Comment;
